import FARE_TYPES from './fare-types';
import {ATC_DATE_FORMAT} from '../../../services/atcFlightSearchParams';
import {tripStates} from '../../../../trip/trip-routes';
import {atcStates} from '../../../atc-routes';

export default function AtcFlightFareService(
    $http,
    atcApiService,
    atcFlightsService,
    atcFlightSegmentService,
    atcFlightGroupService,
    atcFlightGroupDaysShiftArrivalService,
    $state,
    atcTimeService,
) {
    'ngInject';

    let fareTypes = [];
    const FARE_TYPES_URL = '/flights/GetFareTypes';

    const messageSuccess = atcFlightsService.infoModal('Successful operation', 'Ticket changer process completed successfully.');
    const messageFail = atcFlightsService.infoModal('Invalid operation', 'Sorry but your flights are not eligible to be changed online. Please contact your travel advisor.');

    return {
        getFareTypes,
        getFareType,
        getCharityFareType,
        getFareTypeById,
        prepareBenefits,
        rebook,
    };

    function getCharityFareType() {
        return getFareTypeById(FARE_TYPES.CHARITY_TYPE);
    }

    function getFareTypeById(fareTypeId) {
        return _.find(fareTypes, {FlightFareType: fareTypeId});
    }

    function getFareType(fareTypeId) {
        return getFareTypes().then(() => getFareTypeById(fareTypeId));
    }

    function getFareTypes() {
        return $http.apiGET(FARE_TYPES_URL, {noSpinner: true, cache: true})
            .then(({data}) => fareTypes = data);
    }

    function prepareBenefits(benefits) {
        const BAGGAGE_ALLOWANCE = 'BaggageAllowance';
        const TICKET_VALIDITY = 'TicketValidity';

        if (!benefits.hasOwnProperty(BAGGAGE_ALLOWANCE)) {
            benefits[BAGGAGE_ALLOWANCE] = 0;
        }

        return Object
            .entries(benefits)
            .filter(([benefit, value]) => benefit === BAGGAGE_ALLOWANCE ? true : !!value)
            .map(([benefit, value]) => {
                let count = angular.isNumber(value) ? value : '';

                if (benefit === BAGGAGE_ALLOWANCE && value > 0) {
                    count = `X${value}`;
                } else if (benefit === TICKET_VALIDITY) {
                    count = `${value}M`;
                }

                return {
                    count,
                    className: benefit.toLowerCase(),
                };
            });
    }

    function rebook(fare, recommendation, params, selectedFlights) {
        const groupIds = [];
        const totalPassengers = +params.Travellers.Adult.value + +params.Travellers.Child.value;

        const segments = recommendation.FlightSegments
            .map((segment) => atcFlightSegmentService.getSelectedGroup(selectedFlights, segment))
            .map((group, index) => {
                groupIds.push(group.FlightGroupId);
                return {
                    isChanged: params.TicketSearchSegments[index].IsChanged,
                    departureDate: atcFlightGroupService.getFirstFlight(group).DepartureDate,
                    arrivalDate: atcFlightGroupService.getLastFlight(group).ArrivalDate,
                    diffDays: atcFlightGroupDaysShiftArrivalService.getDayShiftArrival(group),
                    duration: group.Duration,
                    canBeBooked: group.CanBeBooked,
                    flights: group.Flights,
                };
            });

        const request = {
            PNRLocator: params.Pnr,
            TripId: params.TripId,
            IsAgent: params.IsAgent,
            DepartmentId: params.DepartmentId,
            MkCarrier: recommendation.MarketingCompanyCode,

            Penalty: recommendation.Penalty,
            FareBalance: recommendation.FareBalance,
            HandlingFee: recommendation.HandlingFee,
            BasePrice: recommendation.Penalty + recommendation.FareBalance + recommendation.ResidualValue,
            TaxAmount: recommendation.TaxDifference,
            MarkAmount: recommendation.MarkDifference,
            FareType: fare.FareType,
            FareRecommendation: fare.FareRecommendationGuid,
            Recommendation: recommendation.RecommendationId,
            CacheKey: params.CacheKey,
            FlightGroups: groupIds,

            SearchId: params.SearchId,

            CancelElements: {
                CancelEntry: 'E',
                Qualifier: 1,
                // Numbers: params.TicketSearchSegments.filter((ticket) => ticket.IsChanged).map((seg) => seg.SegmentTattoo),
                Numbers: params.TicketSearchSegments.filter((ticket) => ticket.IsChanged).map((seg) => seg.Tattoos)
                    .reduce((tat1, tat2) => tat1.concat(tat2), []), // all in one line ,
            },
            TicketInfo: {
                PaxInfo: params.SearchTravellers.map((trav) => {
                    return {
                        Tatoo: trav.Tattoo,
                        PaxType: trav.Code,
                        Tickets: [trav.TkNumber],
                    };
                }),
            },
            RebookSegments: params.TicketSearchSegments.filter((ticket) => ticket.IsChanged).map((seg) => seg.Id),
            Segments: segments.filter((seg) => seg.isChanged).map((seg) => {
                return {
                    Bounds: seg.flights.map((flight) => {
                        return {
                            BkClass: flight.BookingClass,
                            FlightNo: flight.FlightNumber.substring(2),
                            DepartureDate: atcTimeService.formatDate(flight.DepartureDate, ATC_DATE_FORMAT),
                            ArrivalDate: atcTimeService.formatDate(flight.ArrivalDate, ATC_DATE_FORMAT),
                            DepartureAirport: flight.DepartureAirport,
                            ArrivalAirport: flight.ArrivalAirport,
                            Carrier: flight.MarketingCompanyCode,
                        };
                    }),
                };
            }),
            Seats: totalPassengers,
        };

        atcApiService.rebook(request)
            .success((data) => {
                if (data.IsError) {
                    messageFail();
                    return;
                }

                messageSuccess();
                //if (!params.TripId) {
                if (!params.FromTripDetails) {
                    $state.go(atcStates.CHECK);
                } else {
                    $state.go(tripStates.TRIP_DETAILS, {
                        id: params.TripId,
                        department: params.DepartmentId,
                    });
                }
            })
            .error(() => {
                messageFail();
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/flight-recommendation/flight-fare/flight-fare-service.js